import { render, staticRenderFns } from "./ClientTeam.vue?vue&type=template&id=2f4efaf4&scoped=true&"
import script from "./ClientTeam.vue?vue&type=script&lang=js&"
export * from "./ClientTeam.vue?vue&type=script&lang=js&"
import style0 from "./ClientTeam.vue?vue&type=style&index=0&id=2f4efaf4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f4efaf4",
  null
  
)

export default component.exports